import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIUtilService } from '../_util/api-util.service'

@Injectable({
  providedIn: 'root'
})
export class AuthAPIService {
  private _authUrl = this._apiUtilService.APIUrl + "/auth/"
  private _registerUrl = this._authUrl + "register"
  private _loginUrl = this._authUrl + "login"
  private _logoutUrl = this._authUrl + "logout"
  private _verifyUrl = this._authUrl + "verify/"
  private _verifyUserIDUrl = this._verifyUrl + "userid"
  private _getPermissionsUrl = this._authUrl + "permissions/get"
  private _resetPasswordUrl = this._authUrl + "reset/password"

  constructor(private http: HttpClient,
    private _apiUtilService: APIUtilService) { }

  registerUser(user){
    return this.http.post<any>(this._registerUrl, user)
  }

  loginUser(user){
    return this.http.post<any>(this._loginUrl, user)
  }

  logoutUser(){
    return this.http.get<any>(this._logoutUrl)
  }

  verifyUserID(){
    return this.http.get<any>(this._verifyUserIDUrl)
  }

  getPermissions(){
    return this.http.get<any>(this._getPermissionsUrl)
  }

  resetPassword(resetData){
    return this.http.post<any>(this._resetPasswordUrl, resetData)
  }
}
